import React from 'react';
import Monitoring from "../../components/monitor/Monitoring";
import ContentBlocker from "../../components/context/ContentBlocker";

export function MonitoringPage(props: {}) {
  return (
    <div className="MonitoringPage">
      <h1>Monitoring</h1>
      <ContentBlocker>
        <Monitoring/>
      </ContentBlocker>
    </div>
  );
}
